import { Type, plainToInstance } from 'class-transformer'

import { LibraryComponentEntry } from './library-component-entry.model'
import { LibraryComponentFolder } from './library-component-folder.model'
import { LibraryDiscipline } from '../library-discipline.model'
import { LibraryItemType } from '@app/features/library-management/store/enums'
import { Money } from '@app/features/scope-overview/model/money.model'
import { Role } from '@app/features/scoping/models/role.model'
import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'
import { User } from '@app/core/model/user.model'

export class LibraryComponent {
  id?: number
  name: string
  fixedPricing?: boolean
  itemType: LibraryItemType
  libraryFolder?: LibraryComponentFolder
  @Type(() => LibraryComponentEntry) libraryComponentEntries: LibraryComponentEntry[]
  @Type(() => ThirdPartyCost) thirdPartyCosts: ThirdPartyCost[]
  quantity?: number
  complexity?: string
  agencyHours?: number
  agencyPrice?: Money
  fixedCostPrice?: Money
  roles?: Role[]
  departments?: any[]
  discipline?: LibraryDiscipline
  language?: string
  createdBy?: User

  getRateCardPrice(): Money {
    let price: Money

    if (this.fixedPricing && this.fixedCostPrice) {
      price = Money.from(this.fixedCostPrice)
    } else if (this.roles?.length) {
      this.roles.forEach((role) => {
        const rolePrice = plainToInstance(Role, role).getRateCardPrice()
        price = price ? price.add(rolePrice) : rolePrice
      })
    }

    return price ? price.multiply(this.quantity) : price
  }
}
